<template>
    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-bar-chart-2-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                            <p class="cf-modal-head__sub">Période : {{ formattedDateRange }}</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">

                        <!-- Filters Section -->
                        <div class="p-6 bg-gray-50 dark:bg-gray-900/50 border-b border-gray-200 dark:border-gray-700">
                            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                <!-- Date Range -->
                                <div class="md:col-span-2 lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div class="space-y-1">
                                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                            Date début
                                        </label>
                                        <input
                                                v-model="datedebut"
                                                @change="refresh"
                                                type="date"
                                                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white transition duration-150"
                                        />
                                    </div>
                                    <div class="space-y-1">
                                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                            Date fin
                                        </label>
                                        <input
                                                v-model="datefin"
                                                @change="refresh"
                                                type="date"
                                                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white transition duration-150"
                                        />
                                    </div>
                                </div>

                                <!-- Search Filters -->
                                <div class="space-y-4">
                                    <div class="space-y-1">
                                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                            Recherche magasin
                                        </label>
                                        <div class="relative">
                                            <input
                                                    v-model="searchword"
                                                    type="text"
                                                    placeholder="Nom du magasin..."
                                                    class="w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white transition duration-150"
                                            />
                                            <div class="absolute left-3 top-2.5">
                                                <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Additional Search Filters (Toggleable) -->
                                <div class="md:col-span-2 lg:col-span-3">
                                    <button
                                            @click="showAdvancedFilters = !showAdvancedFilters"
                                            type="button"
                                            class="flex items-center text-sm text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 mb-2 transition-colors duration-200"
                                    >
                                        <span>Filtres avancés</span>
                                        <svg
                                                :class="['w-4 h-4 ml-1 transform transition-transform duration-200', { 'rotate-180': showAdvancedFilters }]"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                        >
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                                        </svg>
                                    </button>

                                    <transition name="expand">
                                        <div v-if="showAdvancedFilters" class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2">
                                            <div class="space-y-1">
                                                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                                    Recherche caisse
                                                </label>
                                                <input
                                                        v-model="searchwordcaisse"
                                                        type="text"
                                                        placeholder="Nom de la caisse..."
                                                        class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white transition duration-150"
                                                />
                                            </div>
                                            <div class="space-y-1">
                                                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                                    Recherche article
                                                </label>
                                                <input
                                                        v-model="searchwordarticle"
                                                        type="text"
                                                        placeholder="Nom de l'article..."
                                                        class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white transition duration-150"
                                                />
                                            </div>
                                            <div class="space-y-1">
                                                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                                    Recherche collaborateur
                                                </label>
                                                <input
                                                        v-model="searchwordcollaborateur"
                                                        type="text"
                                                        placeholder="Nom du collaborateur..."
                                                        class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white transition duration-150"
                                                />
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                            </div>
                        </div>

                        <!-- Tabs Navigation -->
                        <div class="border-b border-gray-200 dark:border-gray-700">
                            <nav class="flex overflow-x-auto scrollbar-thin" role="tablist">
                                <button
                                        v-for="tab in tabs"
                                        :key="tab.id"
                                        type="button"
                                        @click="activeTab = tab.id"
                                        :class="[
                    'flex-shrink-0 px-4 py-3 text-sm font-medium border-b-2 transition-colors duration-200',
                    activeTab === tab.id
                      ? 'border-primary-500 text-primary-600 dark:text-primary-400 dark:border-primary-400'
                      : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
                  ]"
                                        :aria-selected="activeTab === tab.id"
                                        role="tab"
                                >
                                    {{ tab.label }}
                                </button>
                            </nav>
                        </div>

                        <!-- Tab Content -->
                        <div class="p-6">
                            <!-- Tab Header with Actions -->
                            <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                                <div>
                                    <h3 class="text-lg font-medium text-gray-900 dark:text-white">
                                        {{ activeTabLabel }}
                                    </h3>
                                    <p v-if="activeTabSummary" class="text-sm text-gray-500 dark:text-gray-400 mt-1">
                                        {{ activeTabSummary }}
                                    </p>
                                </div>
                                <div class="flex flex-wrap gap-2">
                                    <select
                                            v-model="itemsPerPage"
                                            class="inline-block px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300
           bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600
           rounded-md shadow-sm hover:bg-gray-50 dark:hover:bg-gray-700
           focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500
           transition-colors duration-200 cursor-pointer"
                                            aria-label="Nombre d'éléments par page"
                                            title="Choisir le nombre d'éléments à afficher par page"
                                    >
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                        <option value="300">300</option>
                                        <option value="1000">1000</option>
                                        <option value="1000000000000000">Afficher tous</option>
                                    </select>
                                    <button
                                            @click="exportData"
                                            class="inline-flex items-center px-4 py-2 bg-primary-600 hover:bg-primary-700
                                            text-white text-sm font-medium rounded-md transition-colors duration-200 focus:outline-none
                                            focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 ti-btn ti-btn-success"
                                    >
                                        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                        Exporter Excel
                                    </button>
                                    <button
                                            @click="printData"
                                            class="inline-flex items-center px-4 py-2 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 text-sm font-medium rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                    >
                                        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                                        </svg>
                                        Imprimer
                                    </button>
                                </div>
                            </div>

                            <!-- Data Table -->
                            <div class="overflow-x-auto border border-gray-200 dark:border-gray-700 rounded-lg">

                                <table :ref="activeTabref" class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                                    <thead class="bg-gray-50 dark:bg-gray-800">
                                    <tr>
                                        <th
                                                v-for="column in activeTabColumns"
                                                :key="column.key"
                                                scope="col"
                                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                                        >
                                            {{ column.label }}
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody class="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-800">
                                    <template v-if="activeTabData.length">
                                        <tr
                                                v-for="(item, index) in paginatedData"
                                                :key="index"
                                                class="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors duration-150"
                                        >
                                            <td
                                                    v-for="column in activeTabColumns"
                                                    :key="column.key"
                                                    class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-300"
                                            >
                                                <template v-if="column.type === 'money'">
                                                    {{ formatMoney(item[column.key]) }}
                                                </template>
                                                <template v-else-if="column.type === 'number'">
                                                    {{ formatNumber(item[column.key]) }}
                                                </template>
                                                <template v-else>
                                                    {{ item[column.key] || '-' }}
                                                </template>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-else>
                                        <tr>
                                            <td :colspan="activeTabColumns.length" class="px-6 py-12 text-center">
                                                <div class="flex flex-col items-center justify-center">
                                                    <svg class="w-12 h-12 text-gray-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                    </svg>
                                                    <p class="text-gray-500 dark:text-gray-400 font-medium">
                                                        Aucune donnée disponible
                                                    </p>
                                                    <p class="text-sm text-gray-400 dark:text-gray-500 mt-1">
                                                        Ajustez vos filtres ou sélectionnez une autre période
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>

                                    <!-- Totals Row -->
                                    <tfoot v-if="activeTabData.length" class="bg-gray-50 dark:bg-gray-800 font-medium">
                                    <tr>
                                        <td
                                                v-for="column in activeTabColumns"
                                                :key="column.key"
                                                class="px-6 py-3 text-sm text-gray-900 dark:text-gray-300 border-t border-gray-200 dark:border-gray-700"
                                        >
                                            <template v-if="column.key === 'montanttotal'">
                                                {{ formatMoney(activeTabTotals.montanttotal) }}
                                            </template>
                                            <template v-else-if="column.key === 'remisetotal'">
                                                {{ formatMoney(activeTabTotals.remisetotal) }}
                                            </template>
                                            <template v-else-if="column.key === 'qte'">
                                                {{ formatNumber(activeTabTotals.qte) }}
                                            </template>
                                            <template v-else-if="column.key === 'marge'">
                                                {{ formatMoney(activeTabTotals.marge) }}
                                            </template>
                                            <template v-else-if="column.key === 'pacout'">
                                                {{ formatMoney(activeTabTotals.pacout) }}
                                            </template>
                                            <template v-else-if="column.key === 'montanttotalrestant'">
                                                {{ formatMoney(activeTabTotals.montanttotalrestant) }}
                                            </template>
                                            <template v-else-if="column.key === 'mtntremise'">
                                                {{ formatMoney(activeTabTotals.mtntremise) }}
                                            </template>
                                        </td>
                                    </tr>
                                    </tfoot>
                                </table>


                            </div>

                            <!-- Pagination -->
                            <div v-if="activeTabData.length > itemsPerPage" class="mt-6 flex items-center justify-between">
                                <div class="text-sm text-gray-500 dark:text-gray-400">
                                    Affichage de {{ (currentPage - 1) * itemsPerPage + 1 }} à
                                    {{ Math.min(currentPage * itemsPerPage, activeTabData.length) }} sur
                                    {{ activeTabData.length }} résultats
                                </div>
                                <div class="flex space-x-2">
                                    <button
                                            @click="currentPage--"
                                            :disabled="currentPage === 1"
                                            :class="[
                      'px-3 py-1 rounded-md text-sm font-medium transition-colors duration-200',
                      currentPage === 1
                        ? 'bg-gray-100 dark:bg-gray-800 text-gray-400 cursor-not-allowed'
                        : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
                    ]"
                                    >
                                        Précédent
                                    </button>
                                    <span class="px-3 py-1 text-sm text-gray-700 dark:text-gray-300">
                    Page {{ currentPage }} sur {{ totalPages }}
                  </span>
                                    <button
                                            @click="currentPage++"
                                            :disabled="currentPage === totalPages"
                                            :class="[
                      'px-3 py-1 rounded-md text-sm font-medium transition-colors duration-200',
                      currentPage === totalPages
                        ? 'bg-gray-100 dark:bg-gray-800 text-gray-400 cursor-not-allowed'
                        : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
                    ]"
                                    >
                                        Suivant
                                    </button>
                                </div>
                            </div>
                </div>
                </div><!-- /cf-dialog-body -->

                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>

    <!-- Print Modal Component -->
    <modalprintrecap ref="modalprintrecap" />
</template>

<script>
    /*import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";*/
    import {
        currencyFormatDE,
        currentDate,
        currentDateTime,
        ExportExcel, FormatNumber,
         isValidDateString,
        randomString
    } from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    import modalprintrecap from "@/components/views/pages/caisse/rapport/modal_printrecap";
    import qrcode from 'qrcode.vue'
    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "RapportCaisseModal",

        watch: {
            activeTab() {
                this.currentPage = 1;
            },

           /* searchword() {
                this.debouncedRefresh();
            },

            searchwordcaisse() {
                this.debouncedRefresh();
            },

            searchwordarticle() {
                this.debouncedRefresh();
            },

            searchwordcollaborateur() {
                this.debouncedRefresh();
            }*/
        },

        computed: {
            formattedDateRange() {
                if (this.datedebut && this.datefin) {
                    return `${this.datedebut} au ${this.datefin}`;
                }
                return '';
            },

            activeTabLabel() {
                const tab = this.tabs.find(t => t.id === this.activeTab);
                return tab ? tab.label : '';
            },

            activeTabColumns() {
                return this.columns[this.activeTab] || [];
            },

            activeTabref() {
                return this.tableref[this.activeTab] || "none";
            },

            activeTabData() {
                switch (this.activeTab) {
                    case 'CAJ': return this.filteredCAJ;
                    case 'CADG': return this.filteredCADG;
                    case 'CAD': return this.filteredCAD;
                    case 'CAF': return this.filteredCAF;
                    case 'CAFGB': return this.filteredCAFGB;
                    default: return [];
                }
            },

            activeTabSummary() {
                const summaries = {
                    CAJ: `${this.filteredCAJ.length} transactions journalières`,
                    CADG: `${this.filteredCADG.length} articles vendus`,
                    CAD: `${this.filteredCAD.length} lignes détaillées`,
                    CAF: `${this.filteredCAF.length} factures`,
                    CAFGB: `${this.filteredCAFGB.length} factures par collaborateur`
                };
                return summaries[this.activeTab];
            },

            activeTabTotals() {
                const data = this.activeTabData;
                const totals = {};

                this.activeTabColumns.forEach(column => {
                    if (column.type === 'money' || column.type === 'number') {
                        totals[column.key] = data.reduce((sum, item) => {
                            const value = parseFloat(item[column.key]) || 0;
                            return sum + value;
                        }, 0);
                    }
                });

                return totals;
            },

            // Filtered data for each tab
            filteredCAJ() {
                return this.applyFilters(this.datatableCAparcaisseparjours, ['nomcaisse']);
            },

            filteredCADG() {
                return this.applyFilters(this.datatableCApararticleparjoursglobal,
                    ['magasin', 'nomcaisse', 'article']);
            },

            filteredCAD() {
                return this.applyFilters(this.datatableCApararticleparjoursdetailles,
                    ['magasin', 'nomcaisse', 'article', 'collaborateur']);
            },

            filteredCAF() {
                return this.applyFilters(this.datatableCAparfactureparcollaborateur,
                    ['nomcaisse', 'collaborateur']);
            },

            filteredCAFGB() {
                return this.applyFilters(this.datatableCAparfactureparcollaborateurglobal,
                    ['nomcaisse', 'collaborateur']);
            },

            // Pagination
            totalPages() {
                return Math.ceil(this.activeTabData.length / this.itemsPerPage);
            },

            paginatedData() {
                const start = (this.currentPage - 1) * this.itemsPerPage;
                const end = start + this.itemsPerPage;
                return this.activeTabData.slice(start, end);
            }
        },
        components: {
            qrcode,
            modalprintrecap,

        },

        data() {
            return {
                isdisplay: false,
                showAdvancedFilters: false,
                activeTab: 'CAJ',
                currentPage: 1,
                itemsPerPage: 10,

                // Filters
                datedebut: currentDate(),
                datefin: currentDate(),
                titlemodal: '',
                searchword: '',
                searchwordcaisse: '',
                searchwordarticle: '',
                searchwordcollaborateur: '',
                numpidcaisse: '',

                // Data
                datatableCAparcaisseparjours: [],
                datatableCApararticleparjoursdetailles: [],
                datatableCApararticleparjoursglobal: [],
                datatableCAparfactureparcollaborateur: [],
                datatableCAparfactureparcollaborateurglobal: [],

                // Tabs configuration
                tabs: [
                    { id: 'CAJ', label: 'CA JOURNALIER', icon: '📊' },
                    { id: 'CADG', label: 'CA GLOBAL (PAR ARTICLE)', icon: '📈' },
                    { id: 'CAD', label: 'CA DÉTAILLÉS (PAR ARTICLE)', icon: '📋' },
                    { id: 'CAF', label: 'CA PAR FACTURE', icon: '🧾' },
                    { id: 'CAFGB', label: 'CA PAR FACTURE PAR COLLABORATEUR', icon: '👥' }
                ],

                // Columns configuration
                columns: {
                    CAJ: [
                        { key: 'document', label: 'DOCUMENT' },
                        { key: 'dateop', label: 'DATE' },
                        { key: 'nomcaisse', label: 'CAISSE' },
                        { key: 'montanttotal', label: 'CA', type: 'money' },
                        { key: 'remisetotal', label: 'REMISE', type: 'money' }
                    ],
                    CADG: [
                        { key: 'document', label: 'DOCUMENT' },
                        { key: 'nomcaisse', label: 'CAISSE' },
                        { key: 'magasin', label: 'MAGASIN' },
                        { key: 'article', label: 'ARTICLE' },
                        { key: 'qte', label: 'QTE', type: 'number' },
                        { key: 'pu', label: 'PU', type: 'number' },
                        { key: 'remisetotal', label: 'REMISE', type: 'money' },
                        { key: 'montanttotal', label: 'MONTANT', type: 'money' },
                        { key: 'pa', label: 'PA', type: 'number' },
                        { key: 'pacout', label: 'MONTANT COÛT', type: 'money' },
                        { key: 'marge', label: 'MARGE', type: 'money' }
                    ],
                    CAD: [
                        { key: 'document', label: 'DOCUMENT' },
                        { key: 'docref', label: 'N° DOCUMENT' },
                        { key: 'dateop', label: 'DATE' },
                        { key: 'nomcaisse', label: 'CAISSE' },
                        { key: 'collaborateur', label: 'COLLABORATEUR' },
                        { key: 'magasin', label: 'MAGASIN' },
                        { key: 'article', label: 'ARTICLE' },
                        { key: 'qte', label: 'QTE', type: 'number' },
                        { key: 'pu', label: 'PU', type: 'number' },
                        { key: 'remisetotal', label: 'REMISE', type: 'money' },
                        { key: 'montanttotal', label: 'MONTANT', type: 'money' },
                        { key: 'pa', label: 'PA', type: 'number' },
                        { key: 'pacout', label: 'MONTANT COÛT', type: 'money' },
                        { key: 'marge', label: 'MARGE', type: 'money' },
                        { key: 'datesystem', label: 'DATE SYSTÈME' }
                    ],
                    CAF: [
                        { key: 'document', label: 'DOCUMENT' },
                        { key: 'docref', label: 'N° DOCUMENT' },
                        { key: 'dateop', label: 'DATE' },
                        { key: 'nomcaisse', label: 'CAISSE' },
                        { key: 'collaborateur', label: 'COLLABORATEUR' },
                        { key: 'mtntremise', label: 'REMISE', type: 'money' },
                        { key: 'montanttotal', label: 'MONTANT', type: 'money' },
                        { key: 'montanttotalrestant', label: 'MONTANT RESTANT', type: 'money' },
                        { key: 'datesystem', label: 'DATE SYSTÈME' }
                    ],
                    CAFGB: [
                        { key: 'document', label: 'DOCUMENT' },
                        { key: 'dateop', label: 'DATE' },
                        { key: 'nomcaisse', label: 'CAISSE' },
                        { key: 'collaborateur', label: 'COLLABORATEUR' },
                        { key: 'mtntremise', label: 'REMISE', type: 'money' },
                        { key: 'montanttotal', label: 'MONTANT', type: 'money' },
                        { key: 'montanttotalrestant', label: 'MONTANT RESTANT', type: 'money' }
                    ]
                },

                tableref:{
                    CAJ:"caj",
                    CADG:"cadg",
                    CAD:"cad",
                    CAF:"caf",
                    CAFGB:"cafgb",


                }
            };
        },
        methods: {
            // Utility methods
            formatMoney(value) {
                return currencyFormatDE(value);
            },

            formatNumber(value) {
                return FormatNumber(value);
            },

            debounce(func, wait) {
                let timeout;
                return function executedFunction(...args) {
                    const later = () => {
                        clearTimeout(timeout);
                        func(...args);
                    };
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                };
            },

            applyFilters(data, filterFields) {
                if (!data) return [];

                return data.filter(item => {
                    // Date range filter
                    if (item.dateop) {
                        const itemDate = new Date(item.dateop);
                        const startDate = new Date(this.datedebut);
                        const endDate = new Date(this.datefin);
                        if (itemDate < startDate || itemDate > endDate) return false;
                    }

                    // Search filters
                    const filters = [
                        { field: 'nomcaisse', value: this.searchwordcaisse },
                        { field: 'magasin', value: this.searchword },
                        { field: 'article', value: this.searchwordarticle },
                        { field: 'collaborateur', value: this.searchwordcollaborateur }
                    ];

                    return filters.every(filter => {
                        if (!filter.value || !filterFields.includes(filter.field)) return true;
                        const itemValue = item[filter.field];
                        return itemValue && itemValue.toLowerCase().includes(filter.value.toLowerCase());
                    });
                });
            },

            // Modal methods
            show(titlemodal, numpidcaisse, datedouverture) {
                //this.titlemodal = titlemodal || this.titlemodal;
                this.titlemodal = titlemodal;
                this.numpidcaisse = numpidcaisse;

                if (datedouverture) {
                    this.datedebut = datedouverture;
                    this.datefin = datedouverture;
                }

                this.isdisplay = true;
                this.$nextTick(() => this.refresh());
            },

            close() {
                this.isdisplay = false;
                this.$emit('closed');
            },

            // Data methods


            async refresh() {
                if (!isValidDateString(this.datedebut) || !isValidDateString(this.datefin)) {
                    return;
                }

                this.$store.dispatch('lancerchargement', true);

                const url = `${process.env.VUE_APP_API_URL}/egl74587kjkjrfdkcaisse771714dfe/c/rapportpointc/${this.datedebut}/${this.datefin}/${this.numpidcaisse}/${this.$store.state.appsociete}/8954fddpap18rapportpointcaisse519151911515/${randomString()}`;

                // try {
                const t = this;
                const response = axios.get(url, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    },
                    withCredentials: true
                });

                /*console.log("$res ***** ",$res)

                const response=await $res

                console.log("response ***** ",response)


                if (response.data.success) {
                    const data = response.data.m;

                    console.log("data.d1 **** ",data.d1)

                    this.datatableCAparcaisseparjours = data.d1 || [];
                    this.datatableCApararticleparjoursdetailles = data.d2 || [];
                    this.datatableCApararticleparjoursglobal = data.d3 || [];
                    this.datatableCAparfactureparcollaborateur = data.d4 || [];
                    this.datatableCAparfactureparcollaborateurglobal = data.d5 || [];
                } else {
                    this.clearData();
                }*/


                await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)
                        t.datatable=[];

                        if(res.data.success){

                            t.datatableCAparcaisseparjours=res.data.m.d1;
                            t.datatableCApararticleparjoursdetailles=res.data.m.d2;
                            t.datatableCApararticleparjoursglobal=res.data.m.d3;
                            t.datatableCAparfactureparcollaborateur=res.data.m.d4;
                            t.datatableCAparfactureparcollaborateurglobal=res.data.m.d5;

                        }
                        else{
                            t.datatableCAparcaisseparjours=[];
                            t.datatableCApararticleparjoursdetailles=[];
                            t.datatableCApararticleparjoursglobal=[];
                            t.datatableCAparfactureparcollaborateur=[];
                            t.datatableCAparfactureparcollaborateurglobal=[];


                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })







                /* } catch (error) {
                     console.error('Error fetching data:', error);
                     this.clearData();
                 } finally {
                     this.$store.dispatch('lancerchargement', false);
                 }*/
            },

            clearData() {
                this.datatableCAparcaisseparjours = [];
                this.datatableCApararticleparjoursdetailles = [];
                this.datatableCApararticleparjoursglobal = [];
                this.datatableCAparfactureparcollaborateur = [];
                this.datatableCAparfactureparcollaborateurglobal = [];
            },

            // Export and Print methods
            exportData() {
                const filename = `${this.titlemodal}_${this.datedebut}_${this.datefin}_${currentDateTime()}`;
                const tableRef = this.activeTab.toLowerCase();
                const elt=this.$refs[tableRef]
                ExportExcel('xlsx', filename, null, null,elt);
            },


            printData() {
                const printMethods = {
                    CAJ: () => this.imprimeretatimprimercajournalier("CHIFFRE D'AFFAIRES JOURNALIER", 'caj'),
                    CADG: () => this.imprimeretatCApararticleparjoursglobal("CHIFFRE D'AFFAIRES GLOBAL (PAR ARTICLE)", 'cadg'),
                    CAD: () => this.imprimeretatCApararticleparjoursdetailles("CHIFFRE D'AFFAIRES DÉTAILLÉS (PAR ARTICLE)", 'cad'),
                    CAF: () => this.imprimeretatimprimercaparfactureparcollaborateur("CHIFFRE D'AFFAIRES PAR FACTURE", 'caf'),
                    CAFGB: () => this.imprimeretatimprimercaparfactureparcollaborateurglobal("CHIFFRE D'AFFAIRES PAR FACTURE PAR COLLABORATEUR", 'cafgb')
                };



                const method = printMethods[this.activeTab];
                if (method) method();
            },

            imprimeretatimprimercajournalier(valuetitre,tableref){
                let $tableref=this.$refs[tableref];


                let tabvalue={
                    titres:valuetitre,
                    numdoc:'',
                    date:currentDateTime(),
                    datedebut:this.datedebut,
                    datefin:this.datefin,
                    listecatalogue:this.listecatalogue,
                    totalca1:this.totalca1,
                    totalremise1:this.totalremise1,
                    titresignataire:'CAISSIER',
                    nomdusignataire:this.$store.state.appusername,
                    tableref:$tableref.toString(),
                    titresponsable:'GERANT',
                    nomduresponsable:'',


                }

                this.$refs.modalprintrecap.show(tabvalue,$tableref);



            },

            imprimeretatCApararticleparjoursdetailles(valuetitre,tableref){

                let $tableref=this.$refs[tableref];

                let tabvalue={
                    titres:valuetitre,
                    numdoc:'',
                    date:currentDateTime(),
                    datedebut:this.datedebut,
                    datefin:this.datefin,
                    tableCApararticleparjoursdetailles:this.tableCApararticleparjoursdetailles,
                    totalqte:this.totalqte,
                    totalremise2:this.totalremise2,
                    totalca2:this.totalca2,
                    titresignataire:'CAISSIER',
                    nomdusignataire:this.$store.state.appusername,
                    tableref:$tableref,
                    titresponsable:'GERANT',
                    nomduresponsable:'',


                }

                this.$refs.modalprintrecap.show(tabvalue,$tableref);
            },

            imprimeretatCApararticleparjoursglobal(valuetitre,tableref){

                let $tableref=this.$refs[tableref];

                let tabvalue={
                    titres:valuetitre,
                    numdoc:'',
                    date:currentDateTime(),
                    datedebut:this.datedebut,
                    datefin:this.datefin,
                    tableCApararticleparjoursglobal:this.tableCApararticleparjoursglobal,
                    totalqte:this.totalqte,
                    totalremise3:this.totalremise3,
                    totalca3:this.totalca3,
                    titresignataire:'CAISSIER',
                    nomdusignataire:this.$store.state.appusername,
                    table:$tableref,
                    titresponsable:'GERANT',
                    nomduresponsable:'',


                }
                this.$refs.modalprintrecap.show(tabvalue,$tableref);

            },

            imprimeretatimprimercaparfactureparcollaborateur(valuetitre,tableref){

                let $tableref=this.$refs[tableref];

                let tabvalue={
                    titres:valuetitre,
                    numdoc:'',
                    date:currentDateTime(),
                    datedebut:this.datedebut,
                    datefin:this.datefin,
                    tableCAparfactureparcollaborateur:this.tableCAparfactureparcollaborateur,
                    totalREMISE:this.totalREMISE,
                    totalmontant:this.totalmontant,
                    totalmontantrestant:this.totalmontantrestant,
                    titresignataire:'CAISSIER',
                    nomdusignataire:this.$store.state.appusername,
                    table:$tableref,
                    titresponsable:'GERANT',
                    nomduresponsable:'',


                }

                this.$refs.modalprintrecap.show(tabvalue,$tableref);

            },

            imprimeretatimprimercaparfactureparcollaborateurglobal(valuetitre,tableref){

                let $tableref=this.$refs[tableref];

                let tabvalue={
                    titres:valuetitre,
                    numdoc:'',
                    date:currentDateTime(),
                    datedebut:this.datedebut,
                    datefin:this.datefin,
                    tableCAparfactureparcollaborateur:this.tableCAparfactureparcollaborateurglobal,
                    totalREMISE:this.totalREMISEglobal,
                    totalmontant:this.totalmontantglobal,
                    totalmontantrestant:this.totalmontantrestantglobal,
                    titresignataire:'CAISSIER',
                    nomdusignataire:this.$store.state.appusername,
                    table:$tableref,
                    titresponsable:'GERANT',
                    nomduresponsable:'',


                }

                this.$refs.modalprintrecap.show(tabvalue,$tableref);
            },



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:92vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1200px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

    /* Transitions */
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s ease;
    }

    .fade-enter-from, .fade-leave-to {
        opacity: 0;
    }

    .slide-enter-active {
        animation: slide-in 0.3s ease-out;
    }

    .slide-leave-active {
        animation: slide-out 0.3s ease-in;
    }

    @keyframes slide-in {
        from {
            transform: translateY(-20px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    @keyframes slide-out {
        from {
            transform: translateY(0);
            opacity: 1;
        }
        to {
            transform: translateY(-20px);
            opacity: 0;
        }
    }

    .expand-enter-active, .expand-leave-active {
        transition: all 0.3s ease;
        overflow: hidden;
    }

    .expand-enter-from, .expand-leave-to {
        max-height: 0;
        opacity: 0;
    }

    .expand-enter-to, .expand-leave-from {
        max-height: 500px;
        opacity: 1;
    }

    /* Custom scrollbar */
    .scrollbar-thin::-webkit-scrollbar {
        height: 4px;
    }

    .scrollbar-thin::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 2px;
    }

    .scrollbar-thin::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 2px;
    }

    .scrollbar-thin::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    /* Table styles */
    .table-container {
        max-height: 400px;
        overflow-y: auto;
    }

    /* Responsive modal */
    @media (max-width: 768px) {
        .cf-dialog--xxl { max-width:100%; }
    }

    /* Loading state */
    .loading-skeleton {
        animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    }

    @keyframes pulse {
        0%, 100% {
            opacity: 1;
        }
        50% {
            opacity: 0.5;
        }
    }
</style>